export const BQ_CONSTS = {
    CLIENT_ENTITY: 'client',
    PLATFORMS: {
        WEB: 'web',
        MOBILE_WEB: 'mobile_web',
    },
    DOMAIN: 'buyers',
    SUB_DOMAIN: 'goats',
    GROUPS: {
        ACTIONS: 'user_action',
        IMPRESSION: 'impression',
        PAGE_VIEW: 'page_view',
        HOVER: 'hover',
    },
    SUB_GROUPS: {
        WEBSITE_ACTIONS: 'website_actions',
        VIEW_IMPRESSION: 'view_impression',
    },
    ACTION_TYPES: {
        CLICK: 'click',
        IMPRESSION: 'impression',
        HOVER: 'hover',
        PAGE_VIEW: 'page_view',
    },
    PAGE: {
        NAME: 'assets_sharing',
    },
    MEDIA_ACTIONS: {
        START: 'play',
        STOP: 'pause',
    },
};

export const EVENT_TYPES = {
    PAGE_VIEW: 'assets_sharing_show',
    CLICKED_ON_ASSET: 'assets_sharing_clicked_on_asset',
    CLICKED_ON_CTA_BUTTON: 'assets_sharing_clicked_on_continue_button',
    HOVERED_ON_SELLER_DETAILS: 'assets_sharing_hovered_on_seller_details',
    ASSET_IS_SHOWN: 'assets_sharing_asset_is_shown',
    FOOTER_IS_SHOWN: 'assets_sharing_footer_is_shown',
    FOOTER_IS_PLAYED: 'assets_sharing_footer_is_played',
    SELLER_IS_CLICKED: 'assets_sharing_clicked_on_seller_details',
};
